export enum ReviewStepFields {
	Name = "name",
	Contact = "contact",
	Fields = "fields",
	Label = "label",
	Id = "id",
	Required = "required",
	Value = "value",
	Description = "description",
}

export interface ReviewStepFieldsItem {
	[ReviewStepFields.Id]?: string;
	[ReviewStepFields.Label]?: string;
	[ReviewStepFields.Required]?: boolean;
	[ReviewStepFields.Value]?: string | string[];
}

export interface ReviewStepForm {
	[ReviewStepFields.Name]?: string;
	[ReviewStepFields.Contact]?: string;
	[ReviewStepFields.Fields]?: ReviewStepFieldsItem[];
	[ReviewStepFields.Description]?: string;
}
